// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236B7280%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-nav {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 0;
}

/* Modal 内的样式优化 */
.class-operation,
.field-operation,
.label-operation {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
}

/* 选择框统一样式 */
.field-select-option,
.class-select-option,
.dbmap-select-option,
.label-select-option {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  margin: 4px 0;
}

.field-select-option:hover,
.class-select-option:hover,
.dbmap-select-option:hover,
.label-select-option:hover {
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.field-select-option:focus,
.class-select-option:focus,
.dbmap-select-option:focus,
.label-select-option:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

/* 输入框统一样式 */
.class-operation input,
.field-operation input,
.label-operation input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: white;
  transition: all 0.3s ease;
  margin: 8px 0;
}

.class-operation input:focus,
.field-operation input:focus,
.label-operation input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.class-operation input:hover,
.field-operation input:hover,
.label-operation input:hover {
  border-color: #3B82F6;
}

/* 按钮组样式 */
.class-operation .org-btn,
.field-operation .org-btn,
.label-operation .org-btn {
  width: 100%;
  min-height: 38px;
  margin: 4px 0;
  font-size: 13px;
}

/* 徽章样式优化 */
.badge {
  padding: 6px 12px;
  margin: 4px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.class-items-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.class-action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: 8px;
}

.class-action-buttons .org-btn {
  width: 100%;
  min-height: 38px;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/LabelsPageModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA,iBAAiB;AACjB;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA,YAAY;AACZ;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;;EAIE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;;EAIE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,YAAY;AACZ;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA,UAAU;AACV;;;EAGE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".navbar-nav {\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 0;\n}\n\n/* Modal 内的样式优化 */\n.class-operation,\n.field-operation,\n.label-operation {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 0;\n}\n\n/* 选择框统一样式 */\n.field-select-option,\n.class-select-option,\n.dbmap-select-option,\n.label-select-option {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n  margin: 4px 0;\n}\n\n.field-select-option:hover,\n.class-select-option:hover,\n.dbmap-select-option:hover,\n.label-select-option:hover {\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.field-select-option:focus,\n.class-select-option:focus,\n.dbmap-select-option:focus,\n.label-select-option:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n/* 输入框统一样式 */\n.class-operation input,\n.field-operation input,\n.label-operation input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #374151;\n  background-color: white;\n  transition: all 0.3s ease;\n  margin: 8px 0;\n}\n\n.class-operation input:focus,\n.field-operation input:focus,\n.label-operation input:focus {\n  outline: none;\n  border-color: #3B82F6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.class-operation input:hover,\n.field-operation input:hover,\n.label-operation input:hover {\n  border-color: #3B82F6;\n}\n\n/* 按钮组样式 */\n.class-operation .org-btn,\n.field-operation .org-btn,\n.label-operation .org-btn {\n  width: 100%;\n  min-height: 38px;\n  margin: 4px 0;\n  font-size: 13px;\n}\n\n/* 徽章样式优化 */\n.badge {\n  padding: 6px 12px;\n  margin: 4px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.class-items-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.class-action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  margin-top: 8px;\n}\n\n.class-action-buttons .org-btn {\n  width: 100%;\n  min-height: 38px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
